<template>
  	<CampaignSaleReport />
</template>

<script>

// @ is an alias to /src
import CampaignSaleReport from "@/components/reports/CampaignSaleReport.vue";

export default {
  name: "CampaignSaleReportView",
  components: {
    CampaignSaleReport,
  },
};
</script>
